export default function PHP_fpassthru() {
  return (
    <div>
      <h1>PHP_fpassthru</h1>
    </div>
  );
}
